// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2NOXC","label":"LabeledBox_label__3eYzG"};